import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: "Personal Development and Goal Setting",
      
      nestedContent: [
        { id: 1, text: "•	Understanding the importance of setting SMART goals.", dummyText: [] },
        { id: 2, text: "•	Creating both short-term and long-term career goals.", dummyText: [] },
        { id: 3, text: "•	Self-reflection and identifying strengths and areas for improvement.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Time Management and Productivity",
      nestedContent: [
        { id: 1, text: "•	Techniques for better time management (Pomodoro, time-blocking, prioritization).", dummyText: [] },
        { id: 2, text: "•	Tools and apps for boosting productivity (Google Calendar, Todoist, Notion).", dummyText: [] },
        
       
      ],
    },
    {
        id: 3,
        title: " Developing a Growth Mindset",
        nestedContent: [
          { id: 1, text: "•	The difference between a fixed mindset and a growth mindset.", dummyText: [] },
          { id: 2, text: "•	Building resilience and embracing challenges.", dummyText: [] },
          { id: 3, text: "•	How to learn from failure and feedback.", dummyText: [] },
         
        
        ],
      },
      
  ];

  const newModuleContent = [
    // New module sections
    {
      id: 1,
      title: " Verbal and Written Communication",
      nestedContent: [
        { id: 1, text: "•	How to communicate clearly and concisely in verbal and written forms.", dummyText: [] },
        { id: 2, text: "•	Writing professional emails and reports.", dummyText: [] },
        { id: 3, text: "•	Listening actively and engaging in meaningful conversations.", dummyText: [] },
       
      ],
    },
    {
      id: 2,
      title: "  Non-Verbal Communication",
      nestedContent: [
        { id: 1, text: "•	Understanding the power of body language, facial expressions, and tone.", dummyText: [] },
        { id: 2, text: "•	Improving your non-verbal cues in meetings and interviews.", dummyText: [] },
       
       
      ],
    },
    {
        id: 3,
        title: " Conflict Resolution and Feedback",
        nestedContent: [
          { id: 1, text: "•	Techniques for resolving conflicts constructively.", dummyText: [] },
          { id: 2, text: "•	Giving and receiving feedback in a professional manner.", dummyText: [] },
          { id: 3, text: "•	The role of empathy in communication and conflict management.", dummyText: [] },
         
        ],
      },
      
     
      
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: "Analytical and Logical Thinking",
      nestedContent: [
        { id: 1, text: "•	How to approach problems methodically and logically.", dummyText: [] },
        { id: 2, text: "•	Breaking down complex issues into manageable parts.", dummyText: [] },
        { id: 3, text: "•	Using logic to make decisions and avoid cognitive biases.", dummyText: [] },
        
       
      ],
    },
    {
      id: 4,
      title: "Creative Problem Solving",
      nestedContent: [
        { id: 1, text: "•	Techniques like brainstorming, SCAMPER, and design thinking.", dummyText: [] },
        { id: 2, text: "•	Thinking outside the box to generate innovative solutions.", dummyText: [] },
       
        
      ],
    },
    {
        id: 5,
        title: " Troubleshooting",
        nestedContent: [
          { id: 1, text: "•	Identifying problems and their root causes.", dummyText: [] },
          { id: 2, text: "•		Methods for troubleshooting and finding effective solutions in real-time.", dummyText: [] },
          
        ],
      },
      
     
  ];
 
  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: "Team Dynamics",
      nestedContent: [
        { id: 1, text: "•	Understanding team roles and how to collaborate effectively.", dummyText: [] },
        { id: 2, text: "•	Building trust and communicating openly within teams.", dummyText: [] },
        { id: 3, text: "•	How to share ideas and listen to others' input.", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: "Working Remotely",
      nestedContent: [
        { id: 1, text: "•	Tools and best practices for remote collaboration (Slack, Zoom, Google Drive).", dummyText: [] },
        { id: 2, text: "•	Managing communication across time zones and team locations.", dummyText: [] },
       
      ],
    },
    {
        id: 7,
        title: "Giving and Receiving Feedback in Teams",
        nestedContent: [
          { id: 1, text: "•	Providing constructive feedback to teammates.", dummyText: [] },
          { id: 2, text: "•	How to be receptive to feedback and use it for improvement.", dummyText: [] },
          { id: 3, text: "•	Managing difficult conversations in a team setting.", dummyText: [] },
        
        ],
      },
      
      
      
  ];

  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: " Building a Professional Network",
      nestedContent: [
        { id: 1, text: "•	The importance of networking and ways to build connections.", dummyText: [] },
        { id: 2, text: "•	How to use LinkedIn, meetups, and industry events for networking.", dummyText: [] },
        { id: 3, text: " •	Staying in touch with contacts and nurturing professional relationships.", dummyText: [] },

       
      ],
    },
    {
      id: 8,
      title: " Validation in Forms",
      nestedContent: [
        { id: 1, text: "•	Validating form inputs in React.", dummyText: [] },
        { id: 2, text: "•	Handling validation errors and displaying messages.", dummyText: [] },
        { id: 3, text: "•	Using libraries like Formik and Yup for form validation.", dummyText: [] },
      ],
    },
    {
        id: 9,
        title: "Mentorship",
        nestedContent: [
          { id: 1, text: "•	Finding a mentor and how to make the most out of mentorship.", dummyText: [] },
          { id: 2, text: "•	How to give back as a mentor when you’re more experienced.", dummyText: [] },
          { id: 3, text: "•	Creating a mutually beneficial mentor-mentee relationship.", dummyText: [] },
        ],
      },
      
      {
        id: 10,
        title: "Personal Branding",
        nestedContent: [
          { id: 1, text: "•	How to build and maintain your personal brand online (LinkedIn, portfolio, blog).", dummyText: [] },
          { id: 2, text: "•	Showcasing your skills, achievements, and professional persona.", dummyText: [] },
         
        ],
      },
      
  ];

  const extraAdvancedModuleContent = [
    // Extra Advanced Module Sections
    {
      id: 9,
      title: "   Career Pathways and Development",
      nestedContent: [
        { id: 1, text: "•	Understanding different career pathways in tech or other industries.", dummyText: [] },
        { id: 2, text: "•	Setting up a career development plan and tracking progress.", dummyText: [] },
        { id: 3, text: " •	Adjusting your strategy as your career evolves.", dummyText: [] },
      ],
     
    },
    {
      id: 10,
      title: "Job Search and Interview Skills",
      nestedContent: [
        { id: 1, text: "•	Preparing for job interviews: common questions and how to answer.", dummyText: [] },
        { id: 2, text: "•	Tailoring your resume and cover letter for specific roles.", dummyText: [] },
        { id: 3, text: " •	How to succeed in behavioral interviews and technical assessments.", dummyText: [] },
      ],
     

    },
    {
      id: 11,
      title: "Salary Negotiation and Career Growth",
      nestedContent: [
        { id: 1, text: "•	Understanding salary expectations and how to negotiate compensation.", dummyText: [] },
        { id: 2, text: "•	Techniques for asking for raises and promotions.", dummyText: [] },
        { id: 3, text: "•	Managing your work-life balance while advancing your career.", dummyText: [] },
       
      ],
    },
    
  ];


  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'-49px', }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* Existing Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        Comprehensive Career Foundation Skills Curriculum
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
     Effective Communication
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
       Critical Thinking and Problem Solving
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
       Collaboration and Teamwork
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

<div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
  Networking and Professional Relationships
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
      Career Advancement and Strategy
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      
    </div>
  );
};

export default LearningPathTFD;




